<template>
  <div style="font-size:15px;margin-top:2px;margin-left: 20px;display: inline-block;">
    <span v-if="normal" class="us-span"><i style="color:#1890ff" class="fa fa-circle-o-notch fa-spin fa fa-fw" /> 检测中</span>
    <span v-else class="us-span"><i style="color:#9E9E9E" class="fa fa-circle-o-notch" /> 暂停检测</span>
  </div>
</template>

<script>
export default {
  name: 'DeviceStateIcon',
  components: {},
  props: {
    normal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {}
}
</script>

<style scoped>
.us-span{
  font-size: 14px;
  color: #aaa;
}
</style>
